import { render, staticRenderFns } from "./adminClients.vue?vue&type=template&id=dbf44866&scoped=true&"
import script from "./adminClients.vue?vue&type=script&lang=js&"
export * from "./adminClients.vue?vue&type=script&lang=js&"
import style0 from "./adminClients.vue?vue&type=style&index=0&id=dbf44866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf44866",
  null
  
)

export default component.exports